import * as React from "react";

import { Alert, AlertContext, AlertType } from "context/alertcontext";

const useAlert = () => {
  const { setAlert } = React.useContext(AlertContext);

  const alerter = React.useCallback(
    (type: AlertType, message: React.ReactElement) => {
      const alert: Alert = {
        type: type,
        message: message,
      };

      setAlert(alert);
    },
    [setAlert]
  );

  return alerter;
};

export default useAlert;
